// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RDmhc","col":"styles_col__Neb2L"};